<p>Empareje <span class="lowercase">{{aEmparejar}}</span> de <strong>Prime Timetable</strong> con sus equivalentes de <strong>MiGLM</strong>.</p>
<table *ngIf="objetos" [formGroup]="form" mat-table [dataSource]="objetos" class="full-width mat-elevation-z4">
    <!-- Position Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element; let i = index"> 
        <div [formGroupName]="i">
            <mat-checkbox (selectionChange)="change($event.value, i)" formControlName="check" color="primary"></mat-checkbox>
        </div>
        </td>
    </ng-container>
  
    <!-- Name Column -->
    <ng-container matColumnDef="origen">
      <th mat-header-cell *matHeaderCellDef> {{aEmparejar}} en Prime Timetable</th>
      <td mat-cell *matCellDef="let element"> {{element.name + ' ' + element.shortName}} </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="destino">
      <th mat-header-cell *matHeaderCellDef> {{aEmparejar}} en MiGLM </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div [formGroupName]="i">
            <mat-form-field class="full-width">
            <mat-select formControlName="id">
                <mat-option *ngFor="let opcion of opciones$ | async" [value]="opcion.id">
                  {{opcion.nombre}}
                </mat-option>
              </mat-select>
        </mat-form-field>
        </div>
    </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['index', 'origen', 'destino']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['index', 'origen', 'destino'];"></tr>
  </table>
  
  